import { render, staticRenderFns } from "./HelpVideo.vue?vue&type=template&id=94d23d48&scoped=true&"
import script from "./HelpVideo.vue?vue&type=script&lang=js&"
export * from "./HelpVideo.vue?vue&type=script&lang=js&"
import style0 from "./HelpVideo.vue?vue&type=style&index=0&id=94d23d48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d23d48",
  null
  
)

export default component.exports